import React from "react";
import LuvitComponent from "LuvitComponent";
import format from "lib/format";
import moment from "moment";
import SettingStore from "stores/settings";
import config from "lib/config";
import { LinearProgress } from "Components/Base/Feedback/LinearProgress";
import {
  StyledEmptyTag,
  StyledEmptyStars,
  StyledEmptyProgress,
  StyledCardBanner,
  StyledFooterButtonMobileViewport,
  CardNoImage,
  CardFallbackImage,
} from "domains/programs/functions";
import CardIcon from "../../../../domains/programs/components/Program/components/CardIcon";
import {
  OBJECT_TYPE_ONLINE,
  OBJECT_TYPE_CLASSROOM,
  ATTEST_WAITING,
} from "../../../../domains/programs/constants";
import Rating from "lib/components/Rating";
import { Box } from "Components/Base/Layout/Box";
import BaseGrid from "Components/Fragment/BaseGrid";
import { removehtml } from "lib/format";
import { POST } from "lib/api";
import { IconButton } from "Components/Base/Inputs/IconButton";
import { REMOVE } from "Components/Icons";
import CardProgress from "./cardProgress";
import styled from "styled-components";

const dateFormat =
  config && config.shortDateFormat
    ? config.shortDateFormat.toUpperCase()
    : "yyyy-MM-dd HH:mm";
const mobileViewport = window.matchMedia("(max-width: 400px)").matches || false;

const COURSE_TYPE_ONLINE = 1;
const COURSE_TYPE_CLASSROOM = 2;

const StyledBannerContainer = styled.div`
  position: absolute;
  right: 0;
  display: flex;
`;

const StyledCardBannerRelative = styled.div`
  position: relative;
`;

export default class Card extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");
  }

  async componentWillMount() {
    this.setState({
      rating: this.props.course.personalRating.rating,
      comment: this.props.course.personalRating.comment,
    });
  }

  updateRating(newRating, newComment) {
    this.setState({ rating: newRating, comment: newComment });
  }

  renderCardImage(course) {
    let streamType =
      course.courseType == COURSE_TYPE_ONLINE
        ? "coursecoursecatalogue"
        : "courseobjectimage";
    let img = (
      <div
        key="img"
        className="card-image"
        style={{
          backgroundImage:
            "url(" +
            format.url(
              "/utils/streamfile.aspx?type=" +
                streamType +
                "&param=" +
                course.courseId +
                "/" +
                encodeURIComponent(course.image),
            ) +
            ")",
        }}
      />
    );

    if (!course.image) {
      img = <CardFallbackImage title={course.title ? course.title : ""} />;
    }

    return img;
  }

  warningTag(course) {
    if (course.requested) {
      return <span className="tag-warning">{this.l("courserequested")}</span>;
    }

    if (course.attestStatus === ATTEST_WAITING && !course.completed) {
      return <span className="tag-warning">{this.l("waitingforattest")}</span>;
    }

    return <StyledEmptyTag className="card-empty-tag" />;
  }

  async unregisterFromCourse() {
    if (confirm(this.l("unregisterFromOnlineCourseConfirm"))) {
      const {
        refresh,
        course: { courseId },
      } = this.props;

      await POST(
        "/v1/learning/onlinecourses/:courseId/unregister",
        { courseId },
        {},
      );

      refresh();
    }
  }

  render() {
    const displayCardImage =
      SettingStore.getSettingValue("showcourseimageinportal") === "1";
    let basePath = document.location.pathname;
    basePath = basePath.replace("activitycentre/activitycentre.aspx", "");

    let course = this.props.course;
    let buttonText;
    let courseType = OBJECT_TYPE_CLASSROOM;

    let isConnectedToMicrosoftTeams = false;
    if (course.microsoftTeamId) {
      isConnectedToMicrosoftTeams = true;
    }

    if (course.courseType == COURSE_TYPE_ONLINE) {
      courseType = OBJECT_TYPE_ONLINE;
      buttonText = this.l("continue");

      if (course.completed) {
        buttonText = this.l("show");
      } else if (!course.lastLoggedIn) {
        buttonText = this.l("start");
      }
    } else {
      buttonText = this.l("showcoursesessions");
    }

    let time = "";

    if (course.durationHours || course.durationMinutes) {
      if (course.durationHours && course.durationHours != 0) {
        time = `${course.durationHours}h `;
      }

      if (course.durationMinutes) {
        time += `${course.durationMinutes}${this.l("minutesshort")}`;
      }
    }

    let description = course.description;
    let title = course.title;

    let descriptionClass = "card-description";
    let isRequested =
      course.courseType == COURSE_TYPE_CLASSROOM && course.requested;
    let displayCourseDates = false; //     !isRequested && course.courseType == COURSE_TYPE_CLASSROOM;

    const displayOnlineCourseButton =
      course.courseType == 1 && !this.props.isManagerOrAdmin;
    const onlineCourseURL = course.munioURL
      ? course.munioURL
      : `${basePath}education/entercourse.aspx?from=ml&courseid=${course.courseId}`;

    //const courseType = getCourseType(course.courseType);

    if (course.courseType == COURSE_TYPE_CLASSROOM) {
      descriptionClass += " card-description-classroom";
    }
    return (
      <div
        style={{ position: "relative" }}
        id={`learningActivityCard${course.courseId}`}
        className={`learningActivityCard ${
          this.props.mode === "full" ? "card card-big" : "card"
        } animated fadeInDown`}
      >
        <Box position="absolute" top={10} left={16}>
          <CardIcon type={course.courseType} />
        </Box>

        {displayCardImage ? this.renderCardImage(course) : <CardNoImage />}

        <StyledBannerContainer>
          {course.completed && (
            <StyledCardBannerRelative>
              <span className="tag-completed">{this.l("completed")}</span>
            </StyledCardBannerRelative>
          )}

          {isConnectedToMicrosoftTeams && !course.completed && (
            <StyledCardBannerRelative>
              <span className="tag-microsoftTeams">
                {this.l("connectedToTeams")}
              </span>
            </StyledCardBannerRelative>
          )}

          {course.allowUsersToUnregister && !course.completed && (
            <Box
              position="relative"
              top={6}
              right={6}
              onClick={() => this.unregisterFromCourse()}
            >
              <IconButton
                title={this.l("unregisterFromCourse")}
                icon={<REMOVE />}
              />
            </Box>
          )}
        </StyledBannerContainer>

        <div
          className={`card-info ${
            displayCardImage
              ? "card-image-margin-top"
              : "card-no-image-margin-top"
          }`}
        >
          <div className={`${isRequested ? "flex flex-space-b align-c" : ""}`}>
            <h3 title={title} id="learningActivityCardTitle">
              {title}
            </h3>
          </div>

          <BaseGrid justifyContent={"space-between"} childWidth="auto">
            {course.allowRating && !isRequested ? (
              <Rating
                currentRating={this.state.rating || 0}
                currentComment={this.state.comment || ""}
                type={courseType}
                objectId={course.courseId}
                updateRating={this.updateRating.bind(this)}
                readOnly={false}
                managerView={this.props.isManagerOrAdmin}
              />
            ) : (
              <StyledEmptyStars />
            )}
            {time && (
              <Box>
                <span className="icon-clock" aria-hidden="true" />
                {time}
              </Box>
            )}
          </BaseGrid>
          {displayCourseDates && (
            <div>
              <span className="fa fa-calendar" />
              &nbsp;
              {moment().isAfter(course.courseStarts) && (
                <span>
                  {this.l("enddate") +
                    ": " +
                    moment(course.courseEnds).format(dateFormat)}
                </span>
              )}
              {moment().isBefore(course.courseStarts) && (
                <span>
                  {this.l("startdate") +
                    ": " +
                    moment(course.courseStarts).format(dateFormat)}
                </span>
              )}
            </div>
          )}
          <div className={descriptionClass} title={removehtml(description)}>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <div className="fadeout" />
          </div>

          {course.courseType == COURSE_TYPE_ONLINE ? (
            <CardProgress {...this.props} langugageContext={this.l} />
          ) : (
            <StyledEmptyProgress />
          )}

          {this.props.mode !== "full" && <StyledEmptyProgress />}

          {this.warningTag(course)}

          <div className={`card-footer flex flex-wrap flex-space-b`}>
            {displayOnlineCourseButton && (
              <div className="flex flex-end">
                <a
                  href={onlineCourseURL}
                  {...(course.munioURL && { target: "_blank" })}
                >
                  {buttonText}
                </a>
              </div>
            )}

            {isRequested && !this.props.isManagerOrAdmin && (
              <div className="flex flex-end">
                <a
                  href={`${basePath}activities/ActivityDetails.aspx?inapp=1&id=${course.courseId}`}
                >
                  {this.l("registerHere")}
                </a>
                &nbsp;
              </div>
            )}
            {course.courseType == COURSE_TYPE_CLASSROOM && !isRequested && (
              <span className="flex flex-end">
                <a
                  style={
                    mobileViewport ? StyledFooterButtonMobileViewport : null
                  }
                  onClick={() => this.props.openDetails(course)}
                >
                  {this.l("showactivity")}
                </a>
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Card.defaultProps = {
  course: {
    courseId: 0,
    image: "",
    personalRating: { rating: 0, comment: "" },
  },
};
